import React from "react";
import { Button } from "../components/ui/button";
import { useAuth } from "../context/AuthContext";
import { Gift, Copy, Users, Trophy } from "lucide-react";
import { toast } from "../hooks/use-toast";

export default function Convide() {
  const { user } = useAuth();
  const code = React.useMemo(() => (user?.user_id || "CONVITE").replace("user_", "").slice(0, 8).toUpperCase(), [user]);
  const link = `${window.location.origin}/login?ref=${code}`;

  const copy = () => {
    navigator.clipboard.writeText(link);
    toast({ title: "Link copiado!" });
  };

  return (
    <div className="space-y-6 max-w-3xl">
      <h1 className="font-display text-3xl font-extrabold">Convide e Ganhe</h1>

      <div className="rounded-2xl bg-gradient-to-br from-tiffany-500 to-tiffany-600 text-white p-8 relative overflow-hidden">
        <div className="absolute -right-10 -top-10 w-56 h-56 rounded-full bg-white/10 blur-2xl" />
        <Gift size={40} className="mb-3 relative" />
        <h2 className="font-display text-2xl font-extrabold relative">Convide amigos e ganhe dias grátis!</h2>
        <p className="opacity-90 mt-1 relative">A cada amigo que assinar, você ganha <strong>30 dias</strong> de plano premium.</p>
      </div>

      <div className="rounded-2xl bg-card border border-border p-6">
        <h3 className="font-display font-bold mb-3">Seu link de convite</h3>
        <div className="flex gap-2">
          <input readOnly value={link} className="flex-1 h-10 px-3 rounded-md border border-input bg-muted text-sm" />
          <Button onClick={copy} className="bg-tiffany-500 hover:bg-tiffany-600 text-white"><Copy size={16} className="mr-1" /> Copiar</Button>
        </div>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
        <div className="rounded-2xl bg-card border border-border p-5">
          <Users className="text-tiffany-500 mb-2" />
          <div className="text-3xl font-display font-extrabold">0</div>
          <div className="text-sm text-muted-foreground">Amigos convidados</div>
        </div>
        <div className="rounded-2xl bg-card border border-border p-5">
          <Trophy className="text-tiffany-500 mb-2" />
          <div className="text-3xl font-display font-extrabold">0</div>
          <div className="text-sm text-muted-foreground">Dias grátis conquistados</div>
        </div>
      </div>
    </div>
  );
}
